function bankModulecashLifting() {

    let cashLiftingService = [
        {
            name: "Cash Lifting",
            icon: "Cash Lifting",
            logoName: "cash_Lifting",
            // flag: "voucherRequired",
            displayService: "bankModulecashLifting",
            items: [],
        }
    ]

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/cashlifting-dashboard",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "",
            },
        ];

        return dashboardArr;
    };

    const cashLifting = () => {
        const cashLiftingArr = [
            {
                path: "/index/bank-cashlifting",
                name: "Cash Lifting",
                icon: "Cash Lifting",
                logoName: "cash_Lifting",
                flag: "",
            },
        ];

        return cashLiftingArr;
    }

    let a = dashboard();
    let b = cashLifting();

    cashLiftingService[0].items = [...a, ...b];

    return cashLiftingService;
}

export default bankModulecashLifting;